import { render, staticRenderFns } from "./CampaignMassiveCreationTable.vue?vue&type=template&id=6b57ac58&scoped=true&"
import script from "./CampaignMassiveCreationTable.vue?vue&type=script&lang=js&"
export * from "./CampaignMassiveCreationTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMassiveCreationTable.vue?vue&type=style&index=0&id=6b57ac58&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b57ac58",
  null
  
)

export default component.exports